import * as z from "zod/v4";

export enum ManagedClaimStatus {
  REJECTED = "Rejected",
  NOT_SUBMITTED = "Not Submitted",
  PENDING_DOCS = "Pending Docs",
  UNDER_REVIEW = "Under Review",
  SUBMITTED = "Submitted",
  CLOSED = "Closed",
  APPROVED = "Approved",
  NOT_PROTECTED = "Not Protected",
}

export const getManagedClaimStatus = {
  name: "getManagedClaimStatus" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({ status: z.enum(ManagedClaimStatus) }),
};
